import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectRoutes } from "./hooks/protectRoutes";
import Home from "./pages/student/Home";
import { More } from "./pages/student/More";
import { DigitalTicket } from "./pages/student/DigitalTicket";
import { ProfileInfo } from "./pages/student/ProfileInfo";
import { Login } from "./pages/Login";
import { SignUp } from "./pages/student/SignUp";
import { IsEmailVerified } from "./pages/student/IsEmailVerified";
import { AccountPending } from "./pages/student/AccountPending";
import { Verified } from "./pages/student/Verified";
import { SetUp } from "./pages/attendant/SetUp";
import { ScanTicket } from "./pages/attendant/ScanTicket";
import { QrScan } from "./pages/attendant/QrScan";
import { Unauthorized } from "./pages/Unauthorized";
import Missing from "./pages/Missing";
import { TransactionHistory } from "./pages/student/TransactionHistroy";
// import { AdminApp } from "./pages/admin/admin.app"

const ROLES = [0, 1, 2];

// const MainRedirect = () => {

// }

function Router() {
  return (
    <Routes>
      {/* <Route path="/admin" element={<AdminApp />} /> */}

      <Route path="/signup" element={<SignUp />}></Route>
      <Route path="/login" element={<Login />}></Route>
      <Route path="/unauthorized" element={<Unauthorized />}></Route>
      <Route path="/" element={<Navigate to="/login" />}></Route>

      {/* "/" Protected */}
      {/* <Route path="/" element={<MainRedirect />}></Route> */}

      {/* Protected Routes */}
      <Route element={<ProtectRoutes allowedRole={ROLES[2]} />}>
        <Route path="/home" element={<Home />}></Route>
        <Route path="/more" element={<More />}></Route>
        {/* <Route path="/notofications" element={<Notifications />}></Route> */}
        <Route path="/generateticket" element={<DigitalTicket />}></Route>
        <Route path="/profile" element={<ProfileInfo />}></Route>
        <Route path="/isemailverified" element={<IsEmailVerified />}></Route>
        <Route path="/accountpending" element={<AccountPending />}></Route>
        <Route path="/verified" element={<Verified />}></Route>
        <Route path="/transactions" element={<TransactionHistory />}></Route>
      </Route>

      <Route element={<ProtectRoutes allowedRole={ROLES[1]} />}>
        <Route
          path="/"
          element={<Navigate to="/meal-setup" replace={true} />}
        ></Route>
        <Route path="/meal-setup" element={<SetUp />}></Route>
        <Route path="/scanned-transactions" element={<ScanTicket />}></Route>
        <Route path="/qr-scan" element={<QrScan />}></Route>
      </Route>

      {/* catch all */}
      <Route path="*" element={<Missing />} />
    </Routes>
  );
}

export default Router;
